<connex-manage-drivers-drawer #manageDriversDrawer
							  (assignmentsSaved)="loadAssignments()"></connex-manage-drivers-drawer>

<div class="cad-root">
	<div class="cad-filters-card">
		<div class="cad-filters__row">
			<div class="cad-filter cad-filter--date">
				<label class="cad-filter__label" for="cad-service-date">Date</label>
				<div class="cad-date-nav">
					<button pButton
							type="button"
							icon="pi pi-chevron-left"
							class="p-button-outlined cad-date-nav__btn"
							(click)="shiftDate(-1)"
							[attr.aria-label]="'Previous day'"></button>
					<p-calendar inputId="cad-service-date"
								[(ngModel)]="selectedDate"
								(onSelect)="onDatePicked()"
								(onClear)="onDatePicked()"
								dateFormat="M d, yy"
								[iconDisplay]="'input'"
								[showIcon]="true"
								[showOnFocus]="false"
								[readonlyInput]="true"
								styleClass="cad-date-nav__calendar w-full">
						<ng-template pTemplate="inputicon" let-clickCallBack="clickCallBack">
							<i class="pi pi-calendar cad-date-nav__input-icon"
							   (click)="clickCallBack($event)"></i>
						</ng-template>
					</p-calendar>
					<button pButton
							type="button"
							icon="pi pi-chevron-right"
							class="p-button-outlined cad-date-nav__btn"
							(click)="shiftDate(1)"
							[attr.aria-label]="'Next day'"></button>
				</div>
				</div>
			<div class="cad-filter">
				<label class="cad-filter__label" for="cad-slot-filter">Slots</label>
				<p-dropdown inputId="cad-slot-filter"
							[options]="slotOptions"
							[(ngModel)]="slotFilter"
							optionLabel="label"
							optionValue="value"
							styleClass="w-full cad-filter-dropdown"
							(onChange)="onFiltersChanged()"></p-dropdown>
			</div>
			<div class="cad-filter">
				<label class="cad-filter__label" for="cad-route-filter">Routes</label>
				<p-dropdown inputId="cad-route-filter"
							[options]="routeOptions"
							[(ngModel)]="routeFilterKey"
							optionLabel="label"
							optionValue="value"
							styleClass="w-full cad-filter-dropdown"
							(onChange)="onFiltersChanged()"></p-dropdown>
			</div>
			<div class="cad-filter">
				<label class="cad-filter__label" for="cad-status-filter">Status</label>
				<p-dropdown inputId="cad-status-filter"
							[options]="statusOptions"
							[(ngModel)]="statusFilter"
							optionLabel="label"
							optionValue="value"
							styleClass="w-full cad-filter-dropdown"
							(onChange)="onFiltersChanged()"></p-dropdown>
			</div>
		</div>
	</div>

	<div class="cad-kpi-row">
		<div class="cad-kpi-card" *ngFor="let card of kpiCards">
			<div class="cad-kpi-card__head">
				<span class="cad-kpi-card__title">{{ card.title }}</span>
				<i class="cad-kpi-card__icon" [ngClass]="card.icon"></i>
			</div>
			<p class="cad-kpi-card__value">{{ card.value }}</p>
		</div>
	</div>

	<p class="cad-slots-heading" *ngIf="hasLoaded && !loading">
		<span class="cad-slots-heading__count">{{ slots.length }}</span>
		<span class="cad-slots-heading__text">{{ slots.length === 1 ? ' Slot on ' : ' Slots on ' }}</span>
		<span class="cad-slots-heading__date">{{ formatHeadingDate(selectedDate) }}</span>
	</p>

	<div *ngIf="loading && !hasLoaded" class="cad-loading">
		<p-progressSpinner strokeWidth="4" animationDuration=".8s"></p-progressSpinner>
	</div>

	<div *ngIf="hasLoaded && !loading && slots.length === 0" class="cad-empty">
		<p class="cad-empty__title">No slots for this date</p>
		<p class="cad-empty__body">Try another date or adjust the route and status filters.</p>
	</div>

	<div class="cad-slot-list" *ngIf="hasLoaded && slots.length > 0">
		<article class="cad-slot-card" *ngFor="let slot of slots">
			<div class="cad-slot-card__row">
				<div class="cad-slot-card__time">
					<ng-container *ngIf="slotTimeParts(slot.DepartureAt) as tp">
						<span class="cad-slot-card__date">{{ tp.dateLine }}</span>
						<span class="cad-slot-card__clock">{{ tp.timeLine }}</span>
						<span class="cad-slot-card__meridiem">{{ tp.meridiem }}</span>
					</ng-container>
				</div>

				<div class="cad-slot-card__main">
					<div class="cad-slot-card__title-row">
						<span class="cad-slot-card__route">{{ slot.RouteName }}</span>
						<span class="cad-slot-card__status-tag"
							  *ngFor="let label of slotStatusLabels(slot)"
							  [ngClass]="'cad-slot-card__status-tag--' + label.tone">{{ label.text }}</span>
					</div>
					<p class="cad-slot-card__zones">{{ slot.PickupZoneName }} → {{ slot.DropoffZoneName }}</p>
					<p class="cad-slot-card__meta">{{ slotMetaLine(slot) }}</p>
				</div>

				<div class="cad-slot-card__metric">
					<span class="cad-slot-card__metric-value"
						  [ngClass]="driversCountClass(slot)">{{ slot.AssignedDriverCount }}</span>
					<span class="cad-slot-card__metric-label">Drivers</span>
				</div>

				<div class="cad-slot-card__metric">
					<span class="cad-slot-card__metric-value">{{ slot.BookedCount }}/{{ slot.CapacityCount }}</span>
					<span class="cad-slot-card__metric-label">Booked</span>
				</div>

				<div class="cad-slot-card__actions">
					<button pButton
							*ngIf="canManageDrivers"
							type="button"
							icon="pi pi-users"
							label="Manage Drivers"
							class="p-button-outlined cad-btn-manage"
							(click)="onManageDrivers(slot)"></button>
					<p class="cad-slot-card__warning"
					   *ngIf="slot.ShowNotBookableWarning">
						This slot will not be bookable until drivers are assigned
					</p>
				</div>
			</div>

			<ng-container *ngIf="slot.AssignedDrivers?.length">
				<hr class="cad-slot-card__divider" />
				<div class="cad-slot-card__assigned-row">
					<span class="cad-slot-card__assigned-label">Assigned:</span>
					<div class="cad-slot-card__assigned-chips">
						<span class="cad-slot-card__driver-chip"
							  *ngFor="let driver of slot.AssignedDrivers">
							<i class="pi pi-user cad-slot-card__driver-chip-icon" aria-hidden="true"></i>
							<span>{{ assignedDriverChipLabel(driver) }}</span>
						</span>
					</div>
				</div>
			</ng-container>
		</article>
	</div>
</div>
